export default __webpack_public_path__ + "b1bca7ab39012802f2877838dd65cb51.png";